import type { Asset } from '@/shared/api/protocol-ts/model/dto_asset_pb';

export const isToothRoiAsset = (asset: Asset) =>
  asset.Kind.case === 'GeneratedReport' &&
  asset.Kind.value.Content.case === 'CBCTGPMPRSubVolume';

export const isToothServerSliceAsset = (asset: Asset) =>
  asset.Kind.case === 'GeneratedReport' &&
  asset.Kind.value.Content.case === 'CBCTGPToothSlice';
